import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_grid2d, use_slice_workspace } from '@/hooks/store/use_slices';
import { REMOTE__grid2d_get_by_entity_type_and_id } from '@/state/grid2d/grid2d_for_entity/REMOTE__grid2d_get_by_entity_type_and_id';
import { is_grid2d_loading } from '@/utils/utils_grid2d';
import { DTO_REQUEST__grid2d_get_by_entity_type_and_id } from '@shared/dto/grid2d/_requests/DTO_REQUEST__grid2d_get_by_entity_type_and_id';

interface Props {
  entity_type: string;
  entity_id: string;
}

export function WATCHER_GRID2D__get_collection({ entity_type, entity_id }: Props) {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (workspace_current.is_stub()) return; //not loaded yet
    if (is_grid2d_loading(entity_type, entity_id)) return; //already loading
    if (grids2d_map.has(entity_id)) return; //already loaded

    let request = new DTO_REQUEST__grid2d_get_by_entity_type_and_id();
    request.workspace_id = workspace_current._id;
    request.entity_type = entity_type;
    request.entity_id = entity_id;

    void dispatch(REMOTE__grid2d_get_by_entity_type_and_id([request]));
  }, [entity_id, workspace_current, entity_type]);

  return <></>;
}
